import env from '@travel/env';

__webpack_public_path__ = `${env('UNIVERSAL_ASSETS_PATH')}/` || '/';
